import React from 'react';
import PropTypes from 'prop-types';

const Plus02 = ({color = 'currentColor', ...props}) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 1L6 11M11 6L1 6"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

Plus02.propTypes = {
  color: PropTypes.string,
};

export default Plus02;
